<template>
  <div class="cart-box">
    <s-header :name="'题库列表'"></s-header>
    <SwipeCell>
      <Card
        title="ZGC医院题库"
        desc="题库编号-01"
        class="goods-card"
        thumb="https://img01.yzcdn.cn/vant/cat.jpeg">
        <template #footer>
          <button size="mini" disable>已使用</button>
        </template>
      </Card>
      <template #right>
        <van-button square text="停止使用" type="danger" class="delete-button"/>
      </template>
    </SwipeCell>
    <SwipeCell>
      <Card
        title="BD医院题库"
        desc="题库编号-02"
        class="goods-card"
        thumb="https://img01.yzcdn.cn/vant/cat.jpeg">
        <template #footer>
          <button size="mini" disable>已使用</button>
        </template>
      </Card>
      <template #right>
        <van-button square text="停止使用" type="danger" class="delete-button"/>
      </template>
    </SwipeCell>
    <TabBar></TabBar>
  </div>
</template>

<script>
  import {reactive, onMounted, computed, toRefs} from 'vue'
  import {useRouter} from 'vue-router'
  import {useStore} from 'vuex'
  import {Toast} from 'vant'
  import TabBar from '@/components/TabBar'
  import sHeader from '@/components/SimpleHeader'
  import {SwipeCell} from 'vant';
  import {Card} from 'vant';

  export default {
    components: {
      TabBar,
      sHeader,
      SwipeCell,
      Card
    },
    setup() {
      const router = useRouter()
      const store = useStore()
      const state = reactive({
        checked: false,
        list: [],
        all: false,
        result: [],
        checkAll: true
      })

      onMounted(() => {
      })

      const goBack = () => {
        router.go(-1)
      }

      const goTo = () => {
        router.push({path: '/home'})
      }
      return {
        ...toRefs(state),
        goBack,
        goTo,
      }
    }
  }
</script>

<style lang="less">
  @import '../common/style/mixin';

  .goods-card {
    margin: 0;
  }

  .delete-button {
    height: 100%;
  }

  .cart-box {
    .cart-header {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 10000;
      .fj();
      .wh(100%, 44px);
      line-height: 44px;
      padding: 0 10px;
      .boxSizing();
      color: #252525;
      background: #fff;
      border-bottom: 1px solid #dcdcdc;

      .cart-name {
        font-size: 14px;
      }
    }

    .cart-body {
      margin: 16px 0 100px 0;
      padding-left: 10px;

      .good-item {
        display: flex;

        .good-img {
          img {
            .wh(100px, 100px)
          }
        }

        .good-desc {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex: 1;
          padding: 20px;

          .good-title {
            display: flex;
            justify-content: space-between;
          }

          .good-btn {
            display: flex;
            justify-content: space-between;

            .price {
              font-size: 16px;
              color: red;
              line-height: 28px;
            }

            .van-icon-delete {
              font-size: 20px;
              margin-top: 4px;
            }
          }
        }
      }

      .delete-button {
        width: 50px;
        height: 100%;
      }
    }

    .empty {
      width: 50%;
      margin: 0 auto;
      text-align: center;
      margin-top: 200px;

      .empty-cart {
        width: 150px;
        margin-bottom: 20px;
      }

      .van-icon-smile-o {
        font-size: 50px;
      }

      .title {
        font-size: 16px;
        margin-bottom: 20px;
      }
    }

    .submit-all {
      margin-bottom: 50px;

      .van-checkbox {
        margin-left: 10px
      }

      .van-submit-bar__text {
        margin-right: 10px
      }

      .van-submit-bar__button {
        background: @primary;
      }
    }

    .van-checkbox__icon--checked .van-icon {
      background-color: @primary;
      border-color: @primary;
    }
  }
</style>
